import { Icon } from '@glade-ai/ui';
import { type FC } from 'react';

import { type Media } from '@/typings/graphql-models';

import s from '../InputComposer.module.scss';

/** Props for ScreenRecordAttachments component. */
type ScreenRecordAttachmentsProps = {
  medias: Pick<Media, 'id'>[];
};

/** Displays screen recording attachments in the compose box footer. */
export const ScreenRecordAttachments: FC<ScreenRecordAttachmentsProps> = ({ medias }) => (
  <>
    {medias.map((media) => (
      <div key={media.id} className={s.loomAttachment}>
        <Icon icon='ph--monitor-arrow-up--regular' size={4} className='text-primary' />
        <span className='caption ms-4'>Screen Recording</span>
      </div>
    ))}
  </>
);
